export class SystemVersion {
    id: number;
    name:  string;
    universalDictionaryId: number;
}
